<template>
  <div>
    <Modal :title="`订单权益 (订单课时：${totalNum})`" v-model="visible" width="815">
      <Table class="compact" size="small" :columns="column" :data="dataList"></Table>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'OrderClassHourModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    fundPackageId: {
      type: Number
    },
    totalNum: {
      type: Number
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let $moment = this.$moment
    return {
      visible: this.value,
      dataList: [],
      column: [
        {
          title: '数量(节|次)',
          width: 135,
          align: 'center',
          key: 'num'
        },
        {
          title: '订单类型',
          width: 135,
          align: 'center',
          key: 'type'
        },
        {
          title: '权益',
          width: 135,
          align: 'center',
          key: 'channel'
        },
        {
          title: '权益说明',
          width: 135,
          align: 'center',
          key: 'remark'
        },
        {
          title: '有效期(天)',
          width: 135,
          align: 'center',
          key: 'effectDays'
        },
        {
          title: '操作人)',
          width: 135,
          align: 'center',
          key: 'creatorName'
        },
      ]
    }
  },
  methods: {
    onLoad () {
      let self = this
      self.$http.get('/fundPackage/list-order-class-hour', { params: {fundPackageId: self.fundPackageId ,uid:self.uid} }).then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.dataList = res.data
        self.visible = true
      })
    }
  },
  watch: {
    value (val) {
      if (val === true) {
        this.onLoad()
      } else {
        this.visible = val
      }
    },
    visible (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderClassHourModal.vue?7632035e